// The DOT CHART visual of a home widget (HOME_WIDGETS_SPEC.md §2): past /
// filled units in the widget hue, the rest on the `layer` wash — the days of
// a month, the products that are healthy, the hours already booked.
//
//   HomeWidgetDots: { dots: (el, s) => el.call('biStockDots', s.root) }
//
// `dots` is an array of booleans (true = hue). Null = not read yet: fourteen
// resting dots pulse as the skeleton. Hidden at S.
export const HomeWidgetDots = {
  class: 'home-widget-visual',
  gridArea: 'visual',
  display: 'none',
  ':is([data-widget-size]:not([data-widget-size="s"])) &': {
    display: 'flex'
  },
  flexWrap: 'wrap',
  alignContent: 'center',
  gap: 'X2',
  minWidth: '0',
  dots: null,
  animation: (el) => (Array.isArray(el.dots) ? 'none' : 'pulse 1.5s ease-in-out infinite'),
  childExtends: 'HomeWidgetDot',
  childrenAs: 'state',
  children: (el) =>
    (Array.isArray(el.dots) ? el.dots : Array.from({ length: 14 }, () => false)).map((on, i) => ({
      key: 'dot' + i,
      on: !!on
    }))
}

// One dot. Two real branches, never null: the resting wash is the `layer`
// theme's own variable, so it flips with the theme like the chip beside it.
export const HomeWidgetDot = {
  tag: 'span',
  boxSize: 'Z',
  flexShrink: '0',
  round: 'radiusPill',
  background: (el, s) => (s && s.on ? '--home-widget-accent' : '--theme-layer-background')
}
